var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-pdf",class:_vm.fileClass},[_c('div',{ref:"file",class:{ pointer: _vm.openLink },attrs:{"src":_vm.fileSrc},on:{"click":_vm.viewOriginal}},[_vm._v(_vm._s(_vm.fileName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435ed4cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helper/FilePDF.vue
// module id = null
// module chunks = 